import {useContext} from "react";
import Button from "../button/button.component";
import {
    InfoContacts,
    Car,
    IllustrationMinus,
    Smoke,
    PreviewPageIllustration,
    InfoText,
    PreviewPageContainer,
    PreviewPageInfo,
    PreviewPageWrapper,
    Telephone,
    Trust
} from "./preview-page.styles";
import telefon from '../../assets/icons/phone.svg';
import whatsapp from '../../assets/icons/whatsapp.svg';
import smoke from '../../assets/img/smoke-min.png';
import car from '../../assets/img/main-reica.png';
import trustRu from '../../assets/img/good-service-ru.png';
import trustRo from '../../assets/img/good-service-ro.png';
import {Link} from "react-scroll";
import { setHashUrl } from "../../utils/hashNavigation";
import {LanguageContext} from "../../contexts/language.context";

import "./styles.scss"

const PreviewPage = ({props}) => {
    // console.log('props', props)
    const {romanianLanguage} = useContext(LanguageContext)
    return (
        <PreviewPageWrapper id="home">
            <PreviewPageContainer className="hero_container">
                <PreviewPageInfo>
                    <InfoText className="hero_info-text">
                        <h1>{props[1]}<br/><span>{props[2]}</span></h1>
                        <span className="intro">{props[3]}</span>
                    </InfoText>
                    <InfoContacts>
                        <a href="https://wa.me/+393895181415">
                            <Button>
                                <img src={whatsapp} alt="" style={{marginRight: '0.5rem', width: '1.25rem', height: '1.25rem'}}/>
                                {props[4]}
                            </Button>
                        </a>

                        <Telephone>
                            <a href="tel:+393895181415">
                                <img src={telefon} alt=""/>
                                <span>+39 389 518 1415</span>
                            </a>
                        </Telephone>
                    </InfoContacts>
                </PreviewPageInfo>

                <PreviewPageIllustration>
                    <IllustrationMinus>
                        <div className="background"></div>
                        <Car>
                            <img src={car} alt=""/>
                        </Car>
                        <Link to="why-us" spy={true} smooth={true} offset={-150} duration={500} onClick={() => setHashUrl("why-us")}>
                            <Trust>
                                <img src={romanianLanguage ? trustRo : trustRu} alt=""/>
                            </Trust>
                        </Link>
                    </IllustrationMinus>
                </PreviewPageIllustration>
            </PreviewPageContainer>
            <Smoke>
                <img src={smoke} alt="smoke"/>
            </Smoke>
        </PreviewPageWrapper>
    )
}
export default PreviewPage;